import { render } from "./FixedBody.vue?vue&type=template&id=4854aacd"
import script from "./FixedBody.vue?vue&type=script&lang=js"
export * from "./FixedBody.vue?vue&type=script&lang=js"

import "./FixedBody.vue?vue&type=style&index=0&id=4854aacd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__